export default "__VITE_ASSET__86e44c3f__"